/** @format */
import { useState } from 'react';
import BusinessListServices from 'components/BusinessList/services/BusinessListServices';

function useBusinessList() {
  const [busibessList, setBusibessList] = useState([]);
  const [businessLoading, setBusinessLoading] = useState(false);
  const getBusinessList = async (val = '') => {
    setBusinessLoading(true);
    try {
      const q = isNaN(val) ? { query: val } : { businessId: val };
      const result = await BusinessListServices.getBusinessList(q);
      const data = result.result;

      if (data.length > 0) {
        let list = [];
        list = data.map((val) => ({
          name: val.name,
          id: val.id,
          label: `${val.name} - ${val.id}`,
          value: val.id,
        }));
        setBusibessList(list);
      }
    } catch (e) {
      console.log('e :', e);
    }

    setBusinessLoading(false);
  };
  return { busibessList, getBusinessList, businessLoading };
}

export { useBusinessList };
